module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nif(model.grantRender){\nconst participants = (resourceData || {}).data || []\nconst nrOfElements = (resourceData || {}).meta || {}\nnrOfElements.registered = nrOfElements.registered || 0\nnrOfElements.rejected = nrOfElements.rejected || 0\nconst statusNames = utils.categoriesToSimpleCategoryDataObject(storage, (resourceData || {}).statusNames || {})\n%><div>\n<h2><%= model.headline || __('events.participantTable.headline') %></h2>\n<div class=\"table-responsive\">\n<table class=\"table table-hover\">\n<thead>\n<tr>\n<td>Name</td>\n<td>Status</td>\n</tr>\n</thead>\n<tbody><%\nif(utils.isEmpty(participants)){\n%><tr class=\"emptyList\">\n<td colspan=\"2\"><%= __('events.participantTable.emptyList') %></td>\n</tr><%\n} else {\nfor(const pd in participants){\nconst participantData   = participants[pd] || {}\nconst participant       = participantData.attributes || {}\n%><tr>\n<td><%= String(`${participant.firstname} ${participant.lastname}`).trim() %></td>\n<td><%= statusNames[participant.status] || participant.status %></td>\n</tr><%\n}\n}\n%></tbody>\n<tfoot>\n<tr>\n<td colspan=\"2\">\n<%= __('events.participantTable.nrOfElements.registered', nrOfElements) %>,\n<%= __('events.participantTable.nrOfElements.rejected', nrOfElements) %>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div><%\n}\n%>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\bootstrap5\\events\\participantTable.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(model.grantRender){
const participants = (resourceData || {}).data || []
const nrOfElements = (resourceData || {}).meta || {}
nrOfElements.registered = nrOfElements.registered || 0
nrOfElements.rejected = nrOfElements.rejected || 0
const statusNames = utils.categoriesToSimpleCategoryDataObject(storage, (resourceData || {}).statusNames || {})

    ; __line = 8
    ; __append("<div>\n<h2>")
    ; __line = 9
    ; __append(escapeFn( model.headline || __('events.participantTable.headline') ))
    ; __append("</h2>\n<div class=\"table-responsive\">\n<table class=\"table table-hover\">\n<thead>\n<tr>\n<td>Name</td>\n<td>Status</td>\n</tr>\n</thead>\n<tbody>")
    ; __line = 18
    ; 
if(utils.isEmpty(participants)){

    ; __line = 20
    ; __append("<tr class=\"emptyList\">\n<td colspan=\"2\">")
    ; __line = 21
    ; __append(escapeFn( __('events.participantTable.emptyList') ))
    ; __append("</td>\n</tr>")
    ; __line = 22
    ; 
} else {
for(const pd in participants){
const participantData   = participants[pd] || {}
const participant       = participantData.attributes || {}

    ; __line = 27
    ; __append("<tr>\n<td>")
    ; __line = 28
    ; __append(escapeFn( String(`${participant.firstname} ${participant.lastname}`).trim() ))
    ; __append("</td>\n<td>")
    ; __line = 29
    ; __append(escapeFn( statusNames[participant.status] || participant.status ))
    ; __append("</td>\n</tr>")
    ; __line = 30
    ; 
}
}

    ; __line = 33
    ; __append("</tbody>\n<tfoot>\n<tr>\n<td colspan=\"2\">\n")
    ; __line = 37
    ; __append(escapeFn( __('events.participantTable.nrOfElements.registered', nrOfElements) ))
    ; __append(",\n")
    ; __line = 38
    ; __append(escapeFn( __('events.participantTable.nrOfElements.rejected', nrOfElements) ))
    ; __append("\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>")
    ; __line = 44
    ; 
}

    ; __line = 46
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\bootstrap5\events\participantTable.ejs

}